import { Component, OnInit, OnDestroy } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import axios from 'src/app/Service/axios';
import axios_2 from 'src/app/Service/axios-dotone';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { BingMaps, XYZ } from 'ol/source';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';

declare let $: any;

@Component({
  selector: 'tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.css']
})
export class TrackerComponent implements OnInit, OnDestroy {

  map: any = {};
  unitId: string = '0';
  routePoints: Array<any> = [];
  unitRoutePoints: Array<any> = [];
  lastLon: any;
  lastLat: any;
  refreshTimer: any;
  carName: string = '';
  carPlate: string = '';
  speed: string = '';
  lastTime: string = '';
  isSatelliteView: boolean = false;
  isCarListMode: boolean = false;
  hasDashCam: boolean = false;
  showFilters: boolean = false;
  mapLayers: any = [];
  tooltipHtml: any;
  vectorSource: any;
  vectorLayer: any;
  carTypes: any;
  serviceAreas: any;
  travelledDistance: any = 0;
  tempAccessToken: number = 0;
  tripId!: number;
  isScreenshot!: boolean;
  clientId!: string;
  channelId!: number;
  isDotOneMap: boolean = true;
  validUntil!: string;
  lastCallTime: string = '';
  cameras: any = [];

  constructor(
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private mapService: MapService,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService
  ) { }

  private useOfflineMap: boolean = (<any>window).bOfflineMap;
  private tileUrl: string = (<any>window).strMapUrl;

  ngOnInit(): void {
    this.route.url.subscribe((segment) => {
      if (segment[0].path == 'carList-Tracker') {
        this.isCarListMode = true;

        setTimeout(() => {
          this.initMap();

          let res = JSON.parse(this.gurdService.decrypt(localStorage.getItem('XmeTCrsX5GCZ')!).toString());

          res.forEach((el: any, i: any) => {
            if (this.routePoints.length != 0) {
              this.mapService.removeMarkerById(`route${el.strUnitID}`, this.map);
              this.mapService.removeMarkerById(`route${el.strUnitID}_start`, this.map);
              this.mapService.removeMarkerById(`route${el.strUnitID}_end`, this.map);
              this.mapService.removeLayerByName(`ArrowName`, this.map);
              this.mapService.removeLayerByName(`route_line`, this.map);
              this.mapService.removeLayerByName(`route_point`, this.map);
            }

            this.routePoints.push({
              index: i,
              fLon: el.fLon,
              fLat: el.fLat,
              iAngle: el.siAngle,
              strTime: el.strTime,
              iSpeed: el.iSpeed,
              id: el?.strUnitId ? el.strUnitId : el.strUnitID,
              carName: el.strFullName,
              strMobileDomain: el.strMobileDomain_strComment,
              strMobileGroup: el.strMobileGroup_strComment,
              strMobileType: el.strMobileType_strComment
            });

            this.unitRoutePoints = this.routePoints.filter((point: any) => {
              return point.id == el.strUnitID
            });

            this.mapService.drawRouteAnimate_New(`route${el.strUnitID}`, this.map, this.unitRoutePoints, res[i]);
          });

          if (res.length > 0) {
            this.mapService.fitMap(res, this.map);
          }
        }, 100);

        setTimeout(() => {
          // Show the car details on hover.
          this.map.on('pointermove', (e: any) => {
            if (e.dragging) return;

            var el = this.mapService.mapPointerMove(
              this.map.getEventPixel(e.originalEvent),
              this.map
            );

            var pixel = this.map.getEventPixel(e.originalEvent);
            var hit = this.map.hasFeatureAtPixel(pixel);

            this.map.getViewport().style.cursor = hit ? 'pointer' : '';

            this.showTooltip(el, true);
          });

          this.map.on('click', (e: any) => {
            if (e.dragging) return;
            setTimeout(() => {
              var el = this.mapService.mapPointerMove(
                this.map.getEventPixel(e.originalEvent),
                this.map
              );
              this.showTooltip(el);
            }, 250);
          });

          this.map.getView().on('propertychange', (e: any) => {
            var tooltip = $('#map_tooltip');
            tooltip.tooltip('hide');
            this.tooltipHtml = null;
          });
        }, 1500);
      }
      else {
        this.route.queryParams.subscribe((params) => {
          if (params['ita']) this.tempAccessToken = params['ita'];
          if (params['client']) this.clientId = params['client'];
          if (params['channel']) this.channelId = params['channel'];
          if (params['map']) this.isDotOneMap = params['map'] !== 'false';
          if (params['id']) this.tripId = params['id'];
          if (params['ScreenShot']) this.isScreenshot = params['ScreenShot'] == 'true' ? true : false;
          if (params['time']) {
            this.validUntil = params['time'];
            this.checkAccessExpiry(true);
          }
        })

        // Draw the cars on the map.
        setTimeout(() => {
          this.initMap();

          this.route.params.subscribe((params) => {
            this.unitId = params['id'];

            // Show all cars.
            if (this.unitId == 'trackAll') {
              this.showFilters = true;
              this.loadCars();
            }
            // Show a single car.
            else {
              setTimeout(async () => {
                // Temporary access.
                if (this.tempAccessToken != 0) {
                  var model = {
                    iTemporaryAccess: this.tempAccessToken,
                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
                    strUnitID: this.unitId
                  };

                  const resp = await axios.post(`TemporaryAccess_LastPosiation`, this.otherService.stringNumberToNumber(model));
                  resp.data = JSON.parse(resp.data)
                  resp.data = resp.data[0];

                  if (resp.data.bDashCam) {
                    this.initDashCam();
                  }

                  if (resp.data?.ISSessionExpired == true) {
                    this.otherService.removeLocalStorage();
                    return this.router.navigate(['login']);
                  }

                  if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');
                  else {
                    if (resp.data.fLon != this.lastLon && resp.data.fLat != this.lastLat) {
                      this.carName = resp.data.strFullName;
                      this.speed = resp.data.iSpeed;

                      if (resp.data.fDistance) {
                        var num = parseFloat(this.travelledDistance) + resp.data.fDistance;
                        this.travelledDistance = (Math.round(num * 100) / 100).toFixed(2)
                      }

                      this.lastTime = resp.data.strTime;
                      this.carPlate = resp.data.strVehicleNo;

                      if (this.routePoints.length != 0) {
                        this.mapService.removeMarkerById('route', this.map);
                        this.mapService.removeMarkerById('route_start', this.map);
                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.routePoints.push({
                        fLon: resp.data.fLon,
                        fLat: resp.data.fLat,
                        iAngle: resp.data.siAngle,
                        strTime: resp.data.strTime,
                        iSpeed: resp.data.iSpeed,
                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.routePoints, resp.data);
                      this.fitToCar(resp.data);
                    }
                  }
                }

                // Temporary tracking.
                if (this.clientId) {
                  let model = {
                    clientId: this.gurdService.decrypt(localStorage.getItem('clientId')!),
                    token: this.gurdService.decrypt(localStorage.getItem('token')!),
                    strUnitID: this.unitId
                  };

                  const resp = await axios_2.post(`GetCar4LiveStream`, this.otherService.stringNumberToNumber(model));

                  if (resp.data.bDashCam) {
                    this.initDashCam();
                  }

                  if (!this.isDotOneMap) return; // Do not draw the coordinates on the map.

                  if (resp.data?.ISSessionExpired == true) {
                    window.open('/live?timeOut=true&sessionExpired=true', "_self");
                  }

                  if (resp.data == null) {
                    window.open('/live?timeOut=true&error=true', "_self");
                  }
                  else {
                    if (resp.data.fLon != this.lastLon && resp.data.fLat != this.lastLat) {
                      this.carName = resp.data.strFullName;
                      this.speed = resp.data.iSpeed;

                      if (resp.data.fDistance) {
                        var num = parseFloat(this.travelledDistance) + resp.data.fDistance;
                        this.travelledDistance = (Math.round(num * 100) / 100).toFixed(2)
                      }

                      this.lastTime = resp.data.strTime;
                      this.carPlate = resp.data.strVehicleNo;

                      if (this.routePoints.length != 0) {
                        this.mapService.removeMarkerById('route', this.map);
                        this.mapService.removeMarkerById('route_start', this.map);
                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.routePoints.push({
                        fLon: resp.data.fLon,
                        fLat: resp.data.fLat,
                        iAngle: resp.data.siAngle,
                        strTime: resp.data.strTime,
                        iSpeed: resp.data.iSpeed,
                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.routePoints, resp.data);
                      this.fitToCar(resp.data);
                    }
                  }
                }
                // Position and tracking.
                else {
                  let model = {
                    ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
                  };

                  const resp = await axios.post(`GetCar?strUnitID=${this.unitId}`, this.otherService.stringNumberToNumber(model));

                  if (resp.data?.ISSessionExpired == true) {
                    this.otherService.removeLocalStorage();
                    return this.router.navigate(['login']);
                  }

                  if (resp.data == null) return this.notifyService.showError('بروز خطا در سامانه');
                  else {
                    if (resp.data.fLon != this.lastLon && resp.data.fLat != this.lastLat) {
                      this.carName = resp.data.strFullName;
                      this.speed = resp.data.iSpeed;

                      var num = parseFloat(this.travelledDistance) + resp.data.fDistance;
                      this.travelledDistance = (Math.round(num * 100) / 100).toFixed(2)

                      this.lastTime = resp.data.strTime;
                      this.carPlate = resp.data.strVehicleNo;

                      if (this.routePoints.length != 0) {
                        this.mapService.removeMarkerById('route', this.map);
                        this.mapService.removeMarkerById('route_start', this.map);
                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.routePoints.push({
                        fLon: resp.data.fLon,
                        fLat: resp.data.fLat,
                        iAngle: resp.data.siAngle,
                        strTime: resp.data.strTime,
                        iSpeed: resp.data.iSpeed,
                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.routePoints, resp.data);
                      this.fitToCar(resp.data);
                    }
                  }
                }
              }, 700);

              // Simulate the live position.
              this.refreshTimer = setInterval(async () => {
                // Temporary access.
                if (this.tempAccessToken != 0) {
                  var model = {
                    iTemporaryAccess: this.tempAccessToken,
                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
                    strUnitID: this.unitId
                  };

                  const resp = await axios.post(`TemporaryAccess_LastPosiation`, this.otherService.stringNumberToNumber(model));
                  resp.data = JSON.parse(resp.data)
                  resp.data = resp.data[0];

                  if (resp.data.bDashCam) {
                    this.initDashCam()
                  }

                  if (resp.data?.ISSessionExpired == true) {
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                  }

                  if (resp.data == null) {
                    this.notifyService.showError('بروز خطا در سامانه');
                    return;
                  }
                  else {
                    if (resp.data.fLon != this.lastLon && resp.data.fLat != this.lastLat) {
                      this.lastLon = resp.data.fLon;
                      this.lastLat = resp.data.fLat;
                      this.carName = resp.data.strFullName;
                      this.speed = resp.data.iSpeed;

                      var num = parseFloat(this.travelledDistance) + resp.data.fDistance;
                      this.travelledDistance = (Math.round(num * 100) / 100).toFixed(2)

                      this.lastTime = resp.data.strTime;
                      this.carPlate = resp.data.strVehicleNo;

                      if (this.routePoints.length != 0) {
                        this.mapService.removeMarkerById('route', this.map);
                        this.mapService.removeMarkerById('route_start', this.map);
                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.routePoints.push({
                        fLon: resp.data.fLon,
                        fLat: resp.data.fLat,
                        iAngle: resp.data.siAngle,
                        strTime: resp.data.strTime,
                        iSpeed: resp.data.iSpeed,
                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.routePoints, resp.data);

                      this.routePoints.forEach((_point: any, index: number) => {
                        if (index % 2 === 0) {
                          if (index > 1) {
                            if (this.routePoints[index - 1].fLon != 0 && this.routePoints[index - 1].fLat != 0) {
                              var marker = this.mapService.craeteArrow(
                                [this.routePoints[index - 1].fLon, this.routePoints[index - 1].fLat],
                                '../../../assets/Img/16.png',
                                `Arrow`,
                                `ArrowName`,
                                {
                                  html: `<span class="text-success">زمان : ${this.routePoints[index - 1].strTime
                                    }</span>
                             <br />
                             <span class="text-danger">سرعت : ${this.routePoints[index - 1].iSpeed
                                    }</span>
                             `,
                                },
                                this.routePoints[index - 1].iAngle
                              );
                              this.map.addLayer(marker);
                            }
                          }
                        }
                      });
                    }
                  }
                }

                // Temporary tracking.
                if (this.clientId) {
                  let model = {
                    clientId: this.gurdService.decrypt(localStorage.getItem('clientId')!),
                    token: this.gurdService.decrypt(localStorage.getItem('token')!),
                    strUnitID: this.unitId
                  };

                  const resp = await axios_2.post(`GetCar4LiveStream`, this.otherService.stringNumberToNumber(model));

                  if (resp.data.bDashCam) {
                    this.initDashCam();
                  }

                  if (!this.isDotOneMap) return; // Do not draw the coordinates on the map.

                  if (resp.data?.ISSessionExpired == true) {
                    window.open('/live?timeOut=true&sessionExpired=true', "_self");
                  }

                  if (resp.data == null) {
                    window.open('/live?timeOut=true&error=true', "_self");
                  }
                  else {
                    if (resp.data.fLon != this.lastLon && resp.data.fLat != this.lastLat) {
                      this.carName = resp.data.strFullName;
                      this.speed = resp.data.iSpeed;

                      if (resp.data.fDistance) {
                        var num = parseFloat(this.travelledDistance) + resp.data.fDistance;
                        this.travelledDistance = (Math.round(num * 100) / 100).toFixed(2)
                      }

                      this.lastTime = resp.data.strTime;
                      this.carPlate = resp.data.strVehicleNo;

                      if (this.routePoints.length != 0) {
                        this.mapService.removeMarkerById('route', this.map);
                        this.mapService.removeMarkerById('route_start', this.map);
                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.routePoints.push({
                        fLon: resp.data.fLon,
                        fLat: resp.data.fLat,
                        iAngle: resp.data.siAngle,
                        strTime: resp.data.strTime,
                        iSpeed: resp.data.iSpeed,
                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.routePoints, resp.data);
                      this.fitToCar(resp.data);
                    }
                  }
                }
                // Position and tracking.
                else {
                  let model = {
                    ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
                    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
                  };

                  const resp = await axios.post(`GetCar?strUnitID=${this.unitId}`, this.otherService.stringNumberToNumber(model));

                  if (resp.data?.ISSessionExpired == true) {
                    this.otherService.removeLocalStorage();
                    this.router.navigate(['login']);
                    return;
                  }

                  if (resp.data == null) {
                    this.notifyService.showError('بروز خطا در سامانه');
                    return;
                  }
                  else {
                    if (resp.data.fLon != this.lastLon && resp.data.fLat != this.lastLat) {
                      this.lastLon = resp.data.fLon;
                      this.lastLat = resp.data.fLat;
                      this.carName = resp.data.strFullName;
                      this.speed = resp.data.iSpeed;

                      var num = parseFloat(this.travelledDistance) + resp.data.fDistance;
                      this.travelledDistance = (Math.round(num * 100) / 100).toFixed(2)

                      this.lastTime = resp.data.strTime;
                      this.carPlate = resp.data.strVehicleNo;

                      if (this.routePoints.length != 0) {
                        this.mapService.removeMarkerById('route', this.map);
                        this.mapService.removeMarkerById('route_start', this.map);
                        this.mapService.removeMarkerById('route_end', this.map);
                      }

                      this.routePoints.push({
                        fLon: resp.data.fLon,
                        fLat: resp.data.fLat,
                        iAngle: resp.data.siAngle,
                        strTime: resp.data.strTime,
                        iSpeed: resp.data.iSpeed,
                      });

                      this.mapService.drawRouteAnimate('route', this.map, this.routePoints, resp.data);

                      this.routePoints.forEach((_point: any, index: number) => {
                        if (index % 2 === 0) {
                          if (index > 1) {
                            if (this.routePoints[index - 1].fLon != 0 && this.routePoints[index - 1].fLat != 0) {
                              var marker = this.mapService.craeteArrow(
                                [this.routePoints[index - 1].fLon, this.routePoints[index - 1].fLat],
                                '../../../assets/Img/16.png',
                                `Arrow`,
                                `ArrowName`,
                                {
                                  html: `<span class="text-success">زمان : ${this.routePoints[index - 1].strTime}</span>
                             <br />
                             <span class="text-danger">سرعت : ${this.routePoints[index - 1].iSpeed}</span>
                             `,
                                },
                                this.routePoints[index - 1].iAngle
                              );
                              this.map.addLayer(marker);
                            }
                          }
                        }
                      });
                    }
                  }
                }
              }, 5000);

            }
          });
        }, 500);

        // Show the car details on hover.
        setTimeout(() => {
          if (this.unitId == 'trackAll') {
            this.map.on('pointermove', (e: any) => {
              if (e.dragging) return;

              var el = this.mapService.mapPointerMove(
                this.map.getEventPixel(e.originalEvent),
                this.map
              );

              var pixel = this.map.getEventPixel(e.originalEvent);
              var hit = this.map.hasFeatureAtPixel(pixel);

              this.map.getViewport().style.cursor = hit ? 'pointer' : '';

              this.showTooltip(el, true);
            });
          }

          this.map.on('click', (e: any) => {
            if (e.dragging) return;
            setTimeout(() => {
              var el = this.mapService.mapPointerMove(
                this.map.getEventPixel(e.originalEvent),
                this.map
              );
              this.showTooltip(el);
            }, 250);
          });

          this.map.getView().on('propertychange', (e: any) => {
            var tooltip = $('#map_tooltip');
            tooltip.tooltip('hide');
            this.tooltipHtml = null;
          });
        }, 1500);

        this.loadServiceAreas();
        this.loadCarTypes();
      }
    })
  }

  ngOnDestroy(): void {
    clearInterval(this.refreshTimer);

    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');

    window.localStorage.removeItem('clientId');
    window.localStorage.removeItem('token');
  }

  initMap() {
    this.vectorSource = new VectorSource({ wrapX: false });

    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
    });

    if (this.useOfflineMap) {
      this.mapLayers.push(
        new TileLayer({
          source: new XYZ({
            url: this.tileUrl,
            attributions: 'Map data © RayanAndishehNasr'
          }),
        })
      );
    }
    else {
      const styles = [
        'AerialWithLabelsOnDemand',
      ];

      let i, ii;
      for (i = 0, ii = styles.length; i < ii; ++i) {
        this.mapLayers.push(
          new TileLayer({
            visible: false,
            preload: Infinity,
            source: new BingMaps({
              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
              imagerySet: styles[i],
            }),
          }),
        );
      }

      this.mapLayers.push(new TileLayer({ source: new OSM({}), }), this.vectorLayer)
    }

    this.map = new Map({
      controls: defaultControls().extend([]),
      layers: this.mapLayers,
      target: 'test',
      view: new View({
        center: olProj.fromLonLat([51.3833554, 35.6770113]),
        zoom: 13,
      }),
    });
  }

  fitToCar(data: any) {
    var maxLatitude = data.fLat;
    var maxLongitude = data.fLon;
    var minLatitude = data.fLat;
    var minLongitude = data.fLon;

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([
      maxLongitude,
      maxLatitude,
    ]);
    var transformedEnd = this.mapService.transformCoordinates2([
      minLongitude,
      minLatitude,
    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
    ];
    view.fit(source);
  }

  showTooltip(item: any, hover?: any) {
    var tooltip: any;

    if (!hover) {
      tooltip = $('#map_tooltip');
    }
    else {
      tooltip = $('#map_tooltips');
    }

    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });

    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });

    if (item.featureLayer) {
      if (item.featureLayer.feature.get('data')) {
        if (!hover) {
          this.tooltipHtml = item.featureLayer.feature.get('data').html;
          tooltip.attr('data-bs-original-title', item.featureLayer.feature.get('data').html).tooltip('show');

          var hoverTooltip = $('#map_tooltips');
          hoverTooltip.tooltip('hide');
        }
        else {
          if (this.tooltipHtml == item.featureLayer.feature.get('data').html) {
            return
          } else {
            tooltip
              .attr(
                'data-bs-original-title',
                item.featureLayer.feature.get('data').html2
              )
              .tooltip('show');
          }
        }

        $('#map-button').click(() => {
          this.router.navigate([
            `/carInfo/${item.featureLayer.feature.get('data').Id}`,
          ]);
          tooltip.tooltip('hide');
          var hoverTooltip = $('#map_tooltip');
          hoverTooltip.tooltip('hide');
        });
      }
    }
    else {
      tooltip.tooltip('hide');
      this.tooltipHtml = null;
    }
  }

  initDashCam = async () => {
    this.checkAccessExpiry();

    if (this.cameras.length > 0) return;

    this.hasDashCam = true;

    let model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      strUnitID: this.unitId,
      ClientId: this.gurdService.decrypt(localStorage.getItem('clientId')!) || '',
      Token: this.gurdService.decrypt(localStorage.getItem('token')!) || '',
    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Dashcam_CheckOnlineFull`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) {
      return this.notifyService.showError(res.strError);
    }

    if (res.Online) {
      if (res.Ch1 == 1 && this.channelId == 0) {
        const dashCam = this.cameras.find((cam: any) => cam.strUnitId == res.IMEI + '-0');
        if (!dashCam) {
          res.strUnitID = res.IMEI;
          this.addOnlineCameras([res])
        }
      }

      if (res.Ch2 == 1 && this.channelId == 1) {
        const dashCam = this.cameras.find((cam: any) => cam.strUnitId == res.IMEI + '-1');
        if (!dashCam) {
          res.strUnitID = res.IMEI;
          this.addOnlineCameras([res])
        }
      }
      else {
        const dashCam = {
          strUnitId: this.unitId + '-' + this.channelId,
          iDeviceCommand: 'ندارد',
          fullName: this.carName,
          channel: this.channelId == 0 ? 'وقایع' : 'کابین',
          strUrl: '',
        }

        const index = this.cameras.indexOf(dashCam);
        if (index == -1) {
          this.cameras.push(dashCam);
        }
      }
    }
    else {
      const dashCam = {
        strUnitId: this.unitId + '-' + this.channelId,
        iDeviceCommand: 'ندارد',
        fullName: this.carName,
        channel: this.channelId == 0 ? 'وقایع' : 'کابین',
        strUrl: '',
      }

      const index = this.cameras.indexOf(dashCam);
      if (index == -1) {
        this.cameras.push(dashCam);
      }
    }
  }

  private checkAccessExpiry(initialize: boolean = false) {
    if (this.validUntil) {
      const ts = Number(this.validUntil);
      const now = new Date().getTime();

      // Redirect when the access has already expired at initialization time.
      if ((ts * 1000) <= now && initialize) {
        window.open('/live?timeOut=true', "_self");
      }
      else if ((ts * 1000) <= now) {
        clearInterval(this.refreshTimer);
      }
    }
  }

  async addOnlineCameras(response: any[]) {
    response.forEach((cam) => {
      if (cam.Online) {
        if (cam.Ch1 == 1 && this.channelId == 0) {
          const dashCam = {
            strUnitId: cam.strUnitID + '-0',
            iDeviceCommand: 'ندارد',
            fullName: cam.strFullName,
            channel: 'وقایع',
            strUrl: cam.strCh1FLVURL,
          }

          const index = this.cameras.indexOf(dashCam);
          if (index == -1) {
            this.cameras.push(dashCam);
          }
        }

        if (cam.Ch2 == 1 && this.channelId == 1) {
          const dashCam = {
            strUnitId: cam.strUnitID + '-1',
            iDeviceCommand: 'ندارد',
            fullName: cam.strFullName,
            channel: 'کابین',
            strUrl: cam.strCh2FLVURL,
          }

          const index = this.cameras.indexOf(dashCam);
          if (index == -1) {
            this.cameras.push(dashCam);
          }
        }
      }
    })
  }

  async removeCamera(item: { strUnitId: any; }) {
    const dashCam = this.cameras.find((cam: any) => cam.strUnitId == item.strUnitId);
    const index = this.cameras.indexOf(dashCam);

    if (index != -1) {
      this.cameras.splice(index, 1);
    }
  }

  async updateCamera(item: { strUnitId: any; }) {
    const dashCam = this.cameras.find((cam: any) => cam.strUnitId == item.strUnitId);

    if (!dashCam) {
      this.cameras.push(item);
    }
    else {
      const index = this.cameras.indexOf(dashCam);
      if (index != -1) {
        this.cameras[index] = dashCam;
      }
    }
  }

  navigateBack() {
    if (this.tempAccessToken != 0) return this.router.navigate(['ta'], { queryParams: { ita: this.tempAccessToken } });
    if (this.unitId == 'trackAll') return this.router.navigateByUrl('/');
    else return this.router.navigate(['carInfo', this.unitId])
  }

  openGuide() {
    this.otherService.guid(2);
  }

  reload() {
    if (this.unitId == 'trackAll') {
      this.routePoints = [];
      return this.loadCars();
    }

    // A single car needs a full reload to restart its map and camera setup.
    window.location.reload();
  }

  toggleBaseMap() {
    if (this.isSatelliteView == false) {
      this.mapLayers[1].setVisible(false);
      this.mapLayers[0].setVisible(true);
    }
    else {
      this.mapLayers[0].setVisible(false);
      this.mapLayers[1].setVisible(true);
    }
    this.isSatelliteView = !this.isSatelliteView;
  }

  loadCars = async () => {
    this.otherService.Showspinner();

    var serviceAreaSelect = document.getElementById('domain') as any;
    var carTypeSelect = document.getElementById('groupCar') as any;

    var model = this.otherService.stringNumberToNumber({
      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      iMobileDomain: serviceAreaSelect?.value || -1,
      tiMobileType: carTypeSelect?.value || -1,
      bFromWeb: true,
      bWithIcon: true,
      bOnlyHasGPS: true,
      strUnitID: '',
      strLastCallTime: this.lastCallTime
    });

    this.mapService.removeLayerByName(`route_point`, this.map);
    this.mapService.removeLayerByName(`route_start`, this.map);
    this.mapService.removeLayerByName(`route_end`, this.map);
    this.mapService.removeLayerByName(`ArrowName`, this.map);

    const resp = await axios.post(`FleetYar_Car_List_New `, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    if (resp.data.length) this.lastCallTime = resp.data[0].strLastCallTime;

    if (resp.data?.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      this.router.navigate(['login']);
      return;
    }

    if (resp.data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    }
    else {
      resp.data.forEach((el: any, i: any) => {
        if (this.routePoints.length != 0) {
          this.mapService.removeMarkerById(`route${el.strUnitID}`, this.map);
          this.mapService.removeMarkerById(`route${el.strUnitID}_start`, this.map);
          this.mapService.removeMarkerById(`route${el.strUnitID}_end`, this.map);
          this.mapService.removeLayerByName(`ArrowName`, this.map);
          this.mapService.removeLayerByName(`route_line`, this.map);
          this.mapService.removeLayerByName(`route_point`, this.map);
        }

        this.routePoints.push({
          index: i,
          fLon: el.fLon,
          fLat: el.fLat,
          iAngle: el.siAngle,
          strTime: el.strTime,
          iSpeed: el.iSpeed,
          id: el?.strUnitId ? el.strUnitId : el.strUnitID,
          carName: el.strFullName,
          strMobileDomain: el.strMobileDomain_strComment,
          strMobileGroup: el.strMobileGroup_strComment,
          strMobileType: el.strMobileType_strComment
        });

        this.unitRoutePoints = this.routePoints.filter((point: any) => {
          return point.id == el.strUnitID
        });

        this.mapService.drawRouteAnimate_New(`route${el.strUnitID}`, this.map, this.unitRoutePoints, resp.data[i]);
      });

      if (resp.data.length > 0) {
        this.mapService.fitMap(resp.data, this.map);
      }
    }

    // Refresh the cars' positions every 30 seconds.
    clearInterval(this.refreshTimer);
    this.refreshTimer = setInterval(async () => {
      var model_New = this.otherService.stringNumberToNumber({
        ID: this.gurdService.decrypt(localStorage.getItem('ID')!),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
        iMobileDomain: serviceAreaSelect?.value || -1,
        tiMobileType: carTypeSelect?.value || -1,
        bFromWeb: true,
        bWithIcon: true,
        bOnlyHasGPS: true,
        strUnitID: '',
        strLastCallTime: this.lastCallTime || ''
      });

      const resp = await axios.post(`FleetYar_Car_List_New`, this.otherService.stringNumberToNumber(model_New));

      if (!resp.data.length) return;

      this.lastCallTime = resp.data[0].strLastCallTime;

      if (resp.data?.ISSessionExpired == true) {
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
        return;
      }

      if (resp.data == null) {
        this.notifyService.showError('بروز خطا در سامانه');
        return;
      }

      // Draw on the map.
      else {
        this.routePoints = []; // Reset so only the freshly received data is drawn.

        resp.data.forEach((el: any, i: any) => {
          this.mapService.removeMarkerById(`route${el.strUnitID}`, this.map);
          this.mapService.removeMarkerById_New(`route${el.strUnitID}_start`, this.map);
          this.mapService.removeMarkerById_New(`route${el.strUnitID}_end`, this.map);

          this.routePoints.push({
            index: i,
            fLon: el.fLon,
            fLat: el.fLat,
            iAngle: el.siAngle,
            strTime: el.strTime,
            iSpeed: el.iSpeed,
            id: el.strUnitID,
            carName: el.strFullName,
            strMobileDomain: el.strMobileDomain_strComment,
            strMobileGroup: el.strMobileGroup_strComment,
            strMobileType: el.strMobileType_strComment
          });

          this.unitRoutePoints = this.routePoints.filter((point: any) => {
            return point.id == el.strUnitID
          });

          if (this.unitRoutePoints.length > 10) {
            this.unitRoutePoints.shift();
            this.routePoints.splice(this.unitRoutePoints[0].index, 1);
          }

          this.mapService.drawRouteAnimate_New(`route${el.strUnitID}`, this.map, this.unitRoutePoints, resp.data[i]);
        });
      }
    }, 30000);
  }

  loadServiceAreas = async () => {
    const resp = await axios.post(
      `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
      {}
    );
    this.serviceAreas = JSON.parse(resp.data);
  }

  loadCarTypes = async () => {
    const resp = await axios.post(`GetMobileType`, {});
    this.carTypes = resp.data;
  };

}
